import React from "react";
import { useNavigate } from "react-router-dom";
import { useSelector } from "react-redux";
import { NotFoundContainer, Codigo, Titulo, Texto, Boton } from "./notFoundStyles";

// Página 404. Ocupa toda la altura (el footer ya no queda pegado arriba) y
// ofrece un botón que lleva a donde tenga sentido según la sesión:
// - con sesión activa → al dashboard (mandarlo al login sería raro);
// - sin sesión (o vencida) → al login (llevarlo al dashboard lo rebotaría).
const NotFound = () => {
  const navigate = useNavigate();
  const currentUser = useSelector((state) => state.user.currentUser);

  // Misma validación que el navbar: hay usuario y el token no venció.
  const sesionActiva =
    currentUser?.expiresAt &&
    Date.now() < new Date(currentUser.expiresAt).getTime();

  const destino = sesionActiva ? "/dashboard" : "/";
  const etiqueta = sesionActiva ? "Volver al inicio" : "Ir al login";

  return (
    <NotFoundContainer>
      <Codigo>404</Codigo>
      <Titulo>Página no encontrada</Titulo>
      <Texto>
        La dirección a la que quisiste entrar no existe o se movió.
      </Texto>
      <Boton type="button" onClick={() => navigate(destino)}>
        {etiqueta}
      </Boton>
    </NotFoundContainer>
  );
};

export default NotFound;
